// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as PaymentConfirmTypes$OrcaPaymentPage from "../Types/PaymentConfirmTypes.bs.js";

function handleDDC(ddcData, iframeId, isPaymentSession, resolve, data, optLogger, paymentMethod) {
  let match = Core__Option.getOr(ddcData, PaymentConfirmTypes$OrcaPaymentPage.defaultDdcData);
  let iframeUrl = match.iframeUrl;
  LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC initiated", "DDC_FLOW", paymentMethod, undefined);
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
    [
      "fullscreen",
      true
    ],
    [
      "param",
      "paymentloader"
    ],
    [
      "iframeId",
      iframeId
    ]
  ]);
  let errorType = "error";
  let errorMessage = "Something went wrong";
  let handleFailure = () => {
    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
    if (!isPaymentSession) {
      Utils$OrcaPaymentPage.postFailedSubmitResponse(errorType, errorMessage);
    }
    resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse(errorType, errorMessage));
  };
  if (iframeUrl === "") {
    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC failed: empty iframe URL", "DDC_FLOW", paymentMethod, "ERROR");
    return handleFailure();
  }
  let timeoutIdRef = {
    contents: undefined
  };
  let messageHandlerRef = {
    contents: undefined
  };
  let iframeRef = {
    contents: undefined
  };
  let cleanup = () => {
    Core__Option.forEach(timeoutIdRef.contents, prim => {
      clearTimeout(prim);
    });
    Core__Option.forEach(messageHandlerRef.contents, h => {
      window.removeEventListener("message", h);
    });
    Core__Option.forEach(iframeRef.contents, prim => {
      prim.remove();
    });
    timeoutIdRef.contents = undefined;
    messageHandlerRef.contents = undefined;
    iframeRef.contents = undefined;
  };
  let handleMessage = ev => {
    try {
      let json = ev.data;
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (!Core__Option.isSome(dict["next_action"])) {
        return;
      }
      let nextAction = PaymentConfirmTypes$OrcaPaymentPage.getNextAction(dict, "next_action");
      let nextActionType = nextAction.type_;
      let redirectUrl = nextAction.postDdcRedirectUrl;
      let redirectMode = nextAction.redirectMode;
      cleanup();
      if (nextActionType === "redirect_to_url" && redirectUrl !== "") {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC completed successfully", "DDC_FLOW", paymentMethod, undefined);
        Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
        if (redirectMode === "if_required") {
          if (isPaymentSession) {
            return resolve(data);
          } else {
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                "openurl_if_required",
                redirectUrl
              ]]);
          }
        }
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "Post DDC redirection", "REDIRECTING_USER", paymentMethod, "INFO");
        return Utils$OrcaPaymentPage.openUrl(redirectUrl);
      } else {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, `DDC failed: invalid next action type - ` + nextActionType, "DDC_FLOW", paymentMethod, "ERROR");
        return handleFailure();
      }
    } catch (raw_exn) {
      let exn = Primitive_exceptions.internalToException(raw_exn);
      let err = JSON.stringify(exn);
      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, `DDC failed: message parse error - ` + err, "DDC_FLOW", paymentMethod, "ERROR");
      cleanup();
      return handleFailure();
    }
  };
  messageHandlerRef.contents = handleMessage;
  window.addEventListener("message", handleMessage);
  let iframe = Utils$OrcaPaymentPage.makeHiddenIframe(document.body, iframeUrl, "ddc-iframe");
  iframeRef.contents = Primitive_option.some(iframe);
  timeoutIdRef.contents = Primitive_option.some(setTimeout(() => {
    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC timed out", "DDC_FLOW", paymentMethod, "ERROR");
    cleanup();
    handleFailure();
  }, match.timeoutMs));
}

export {
  handleDDC,
}
/* Utils-OrcaPaymentPage Not a pure module */
